import { createTheme } from '@mui/material/styles';

// ============================================================================
// Botanical Calm Design System
// ============================================================================

export const SAGE = {
  50:  '#f6f7f5',
  100: '#e8ebe5',
  200: '#d1d7cb',
  300: '#b3bda9',
  400: '#8fa182',
  500: '#6b8c5e',
  600: '#567347',
  700: '#435a37',
  800: '#36472d',
  900: '#2d3a26',
};

export const CREAM = {
  50:  '#fefdfb',
  100: '#faf8f4',
  200: '#f5f0e8',
  300: '#ede5d8',
};

export const WARM = {
  accent: '#d4a574',
  rose:   '#c47a7a',
  gold:   '#b8993e',
};

const theme = createTheme({
  palette: {
    primary: {
      main:  SAGE[500],
      light: SAGE[300],
      dark:  SAGE[700],
      contrastText: '#fff',
    },
    secondary: {
      main: WARM.accent,
    },
    background: {
      default: CREAM[100],
      paper:   CREAM[50],
    },
    text: {
      primary:   SAGE[900],
      secondary: SAGE[600],
    },
  },
  typography: {
    fontFamily: "'Outfit', 'Helvetica Neue', Arial, sans-serif",
    h1: { fontFamily: "'Outfit', sans-serif" },
    h2: { fontFamily: "'Outfit', sans-serif" },
    h3: { fontFamily: "'Outfit', sans-serif" },
    h4: { fontFamily: "'Outfit', sans-serif" },
    h5: { fontFamily: "'Outfit', sans-serif" },
    h6: { fontFamily: "'Outfit', sans-serif" },
    body1: { fontFamily: "'Lora', 'Georgia', serif" },
    body2: { fontFamily: "'Lora', 'Georgia', serif" },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: `linear-gradient(180deg, ${CREAM[100]} 0%, ${CREAM[200]} 100%)`,
          minHeight: '100vh',
        },
      },
    },
  },
});

export default theme;
